import React, {Component} from 'react';
import {Col, FormGroup, Label, Row, Tooltip} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";

class CustomerWarningList extends Component {

	constructor(props) {
		super(props);

		this.state = {
			editRowModal: false,
			showMenu: false,
			selectedRow: null
		};

		this.closeMenu = this.closeMenu.bind(this);
		this.showMenu = this.showMenu.bind(this);
	}

	defineWarningInfo(cw, info) {

		const id = cw.warningOption.recordId;

		if ((id === 1 || id === 3) && info === 'mail') {
			return cw.warningMail;
		} else if ((id === 2 || id === 3) && info === 'phone') {
			return cw.warningPhone;
		} else {
			return '-';
		}
	}

	findIfTargetIfExist() {
		if (document.getElementById('addNewButton')) {
			return true;
		}
	}

	showMenu(row, index) {

		console.log(index)

		let colWidth = document.getElementById('editColumn').getAttribute('class');

		let showMenu = this.state.showMenu;
		if (!showMenu) {
			this.setState({
				showMenu: true,
				selectedRow: row,
				colWidth
			}, () => {
				document.addEventListener('click', this.closeMenu);
			})
		} else {
			this.setState({
				selectedRow: row
			}, () => {
				this.closeMenu(row, true);
			})
		}
	}

	closeMenu(data, isTriggered) {
		if (data && ((data.target && data.target.id === 'editButton') || isTriggered)) {

			let selectedRow = null;

			if (isTriggered) {
				selectedRow = data
			}

			this.setState({
				showMenu: false,
				selectedRow
			}, () => {
				document.removeEventListener('click', this.closeMenu);
				this.showMenu(selectedRow);
			})
		} else {
			this.setState({
				showMenu: false,
				selectedRow: null
			}, () => {
				document.removeEventListener('click', this.closeMenu);
			})
		}
	}

	onRemoveWarning(row, index) {
		this.props.onRemoveWarning(row, index)
	}

	onEditWarning(row, index) {
		this.props.openEditModal(row, index);
	}

	async fetchRecentlyAddedWarning(data) {
		let params = {
			url: `/customer/fetchRecentlyAddedWarning`,
			method: 'post',
			data: data
		};
		let status = null;
		await request(params).then(function (response) {
			status = response.data;
			return status;
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	render() {

		const customerWarnings = this.props.customerWarnings;
		const warningTypesDropdownListSize = this.props.warningTypesDropdownListSize;
		const selectedRow = this.state.selectedRow;

		return (
			<Col sm='12'>
				{customerWarnings && customerWarnings.length > 0 && customerWarnings.map((cw, index) =>
					<Row key={index}>
						<Col sm='3' style={{padding: '0 0 0 5px'}}>
							{customerWarnings.indexOf(cw) === 0 &&
							<Col sm='12' className='tableLikeHeader'>
								<FormGroup>
									<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>Bildirim Türü</Label>
								</FormGroup>
							</Col>}
							<Col sm='12' className='tableLikeCell'>
								<FormGroup>
									<Label className="col-form-label">{cw.warningType.typeExplanation}</Label>
								</FormGroup>
							</Col>
						</Col>

						<Col sm='3' style={{padding: '0px'}}>
							{customerWarnings.indexOf(cw) === 0 &&
							<Col sm='12' className='tableLikeHeader'>
								<FormGroup>
									<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>Bildirim Şekli</Label>
								</FormGroup>
							</Col>}
							<Col sm='12' className='tableLikeCell'>
								<FormGroup>
									<Label className="col-form-label">{cw.warningOption.optionExplanation}</Label>
								</FormGroup>
							</Col>
						</Col>

						<Col sm='3' style={{padding: '0px'}}>
							{customerWarnings.indexOf(cw) === 0 &&
							<Col sm='12' className='tableLikeHeader'>
								<FormGroup>
									<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>e-Posta</Label>
								</FormGroup>
							</Col>}
							<Col sm='12' className='tableLikeCell'>
								<FormGroup>
									<Label className="col-form-label">{this.defineWarningInfo(cw, 'mail')}</Label>
								</FormGroup>
							</Col>
						</Col>

						<Col sm='2' style={{padding: '0px'}}>
							{customerWarnings.indexOf(cw) === 0 &&
							<Col sm='12' className='tableLikeHeader'>
								<FormGroup>
									<Label className="col-form-label" sm="12" style={{fontWeight: 'bold'}}>Telefon</Label>
								</FormGroup>
							</Col>}
							<Col sm='12' className='tableLikeCell'>
								<FormGroup>
									<Label className="col-form-label">{this.defineWarningInfo(cw, 'phone')}</Label>
								</FormGroup>
							</Col>
						</Col>

						<Col sm="1" style={{padding: '0 5px 0 0'}}>
							{customerWarnings.indexOf(cw) === 0 &&
							<Col sm="12" style={{padding: '11px 0 0 0'}}>
								<Label className="col-form-label"/>
							</Col>}

							<Col sm='12' style={{padding: '0 15px 0 15px'}}>
								<Row className='tableLikeCell' style={{padding: '3px 0 3px 0'}}>
									<Col id='editColumn'
										 sm={((customerWarnings.indexOf(cw) - customerWarnings.length !== -1) || this.props.mode === 'create' ||
											 (warningTypesDropdownListSize <= 0)) ? '12' : '6'}
										 style={{padding: '0px', textAlign: 'center'}}>
										<Col sm="12" style={{padding: '0px'}}>
											<button id='editButton' className='simpleButton sEdit' onClick={() => this.showMenu(cw, index)}/>
										</Col>
									</Col>
									{((customerWarnings.indexOf(cw) - customerWarnings.length === -1) && this.props.mode === 'list' &&
										(warningTypesDropdownListSize > 0)) &&
									<Col sm='6' style={{padding: '0px'}}>
										<Col sm="12" style={{padding: '0px'}}>
											<button id='addNewButton' className='simpleButton add' onClick={() => this.props.setModeAsCreate()}/>
											{this.findIfTargetIfExist() && this.props.mode === 'list' && !this.state.showMenu &&
											<Tooltip className='blinker' placement="bottom" target='addNewButton' isOpen={false}>
												Yeni Ekle
											</Tooltip>}
										</Col>
									</Col>}
								</Row>
							</Col>
							{this.state.showMenu && selectedRow && (selectedRow.warningType.typeName === cw.warningType.typeName) &&
							<div className={this.state.colWidth === 'col-sm-6' ? 'editWarningMenu slide' : 'editWarningMenu full slide'}>
								<ul className='editWarningMenuList'>
									<li>
										<button className='editWarningMenuButton' onClick={() => this.onRemoveWarning(cw, index)}>Kaldır</button>
									</li>
									<hr/>
									<li>
										<button className='editWarningMenuButton' onClick={() => this.onEditWarning(cw, index)}>Düzenle</button>
									</li>
								</ul>
							</div>}
						</Col>
					</Row>
				)}
			</Col>
		)
	}
}

export default CustomerWarningList;